import overview from "../../../../assets/images/overview-dark.png";
import * as React from 'react';
export default {
  overview,
  React
};